var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_283_33158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2391 3.24297C19.6282 3.24297 19.952 3.56596 19.952 3.97696V4.35696C19.952 4.75795 19.6282 5.09095 19.2391 5.09095H2.66588C2.27589 5.09095 1.95203 4.75795 1.95203 4.35696V3.97696C1.95203 3.56596 2.27589 3.24297 2.66588 3.24297H5.58159C6.17388 3.24297 6.68933 2.82197 6.82257 2.22798L6.97526 1.54598C7.21256 0.616994 7.99352 0 8.8873 0H13.0168C13.9008 0 14.6905 0.616994 14.9191 1.49699L15.0825 2.22698C15.2147 2.82197 15.7302 3.24297 16.3234 3.24297H19.2391ZM17.7573 17.134C18.0617 14.2971 18.5946 7.55714 18.5946 7.48914C18.6141 7.28314 18.547 7.08814 18.4137 6.93114C18.2708 6.78414 18.0899 6.69714 17.8905 6.69714H4.01997C3.81962 6.69714 3.629 6.78414 3.49673 6.93114C3.36252 7.08814 3.29639 7.28314 3.30611 7.48914C3.3079 7.50163 3.32702 7.73904 3.35899 8.13595C3.50103 9.89919 3.89661 14.8102 4.15223 17.134C4.33313 18.846 5.45643 19.922 7.08351 19.961C8.33907 19.99 9.63257 20 10.9552 20C12.2011 20 13.4664 19.99 14.7608 19.961C16.4443 19.932 17.5666 18.875 17.7573 17.134Z",
    fill: "#FFD456"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_283_33158",
    x: 0.952026,
    y: 0,
    width: 19,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_283_33158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_283_33158",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f478140c7316cfc472fae4731e14ff67.svg";
export { ForwardRef as ReactComponent };